import { IcepackFillerCustomModalCell } from './components/icepack-filler-custom-modal-cell';

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const ICEPACK_FILLER_FORM_NAME = 'icepack-filler-form';

export const REQUIRED_FIELDS = ['name'];

export const FIELDS_FOR_VALIDATE = ['name'];

export const ICEPACK_FILLER_TABLE_COLUMNS_NAMES = [
	{ id: 'title' },
	{ id: 'value', customComponent: IcepackFillerCustomModalCell },
];

export const ICEPACK_FILLER_TABLE_ROWS_NAMES = {
	author: 'Автор',
};
